"use client";

import { useQuery } from "@tanstack/react-query";
import type { AuthUser } from "./base";

export function useUser() {
  const query = useQuery<AuthUser | null>({
    queryKey: ["auth-session"],
    queryFn: async () => {
      const response = await fetch("/auth/profile", { cache: "no-store" });
      if (response.status === 401 || response.status === 204) return null;
      if (!response.ok) throw new Error("Unable to load your session");
      return response.json();
    },
    retry: false,
    staleTime: 60_000,
  });
  return {
    user: query.data,
    isLoading: query.isLoading,
    error: query.error,
    invalidate: async () => (await query.refetch()).data ?? undefined,
  };
}
